@if (isTrialExpired()) {
<div>
	<lib-message [title]="'Client form unavailable'" [type]="'warning'" [hideIcon]="true">
		Your trial period has ended and you can no longer create new clients.
	</lib-message>
</div>
} @else {

<lib-message [dismissId]="'newClientFormInfo'" [type]="'info'" class="push-bottom-md">
	Your clients will be able to log in using the email and password you set here. We'll send them a welcome email with
	their login details, which they can update at any time.
</lib-message>

<div>
	<lib-card [isForm]="true" [title]="'Login details'">
		<ui-text-form-field
			[title]="'E-mail'"
			[isRequired]="true"
			[validation]="'email'"
			[disableAutocomplete]="true"
			[valueAsSignal]="form.email"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-password-form-field
			class="push-top-md"
			[title]="'Password'"
			[disableAutocomplete]="true"
			[isRequired]="true"
			[valueAsSignal]="form.password"
		></ui-password-form-field>
	</lib-card>

	<lib-card [isForm]="true" [title]="'Profile'" class="push-top-md">
		<ui-text-form-field
			[title]="'First name'"
			[valueAsSignal]="form.firstName"
			[disableAutocomplete]="true"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Last name'"
			[valueAsSignal]="form.lastName"
			[disableAutocomplete]="true"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-select-item-field
			class="push-top-md"
			[title]="'Gender'"
			[valueAsSignal]="form.gender"
			[items]="genderSelectItems"
		></ui-select-item-field>

		<ui-select-item-field
			class="push-top-md"
			[placeholder]="'Select unit...'"
			[title]="'Preferred units'"
			[valueAsSignal]="form.preferredUnit"
			[items]="preferredUnitSelectItems"
		></ui-select-item-field>
	</lib-card>

	<lib-card [isForm]="true" [title]="'Physical information'" class="push-top-md">
		<ui-weight-form-field
			class="push-top-md"
			[unit]="form.preferredUnit()"
			[title]="'Weight'"
			[valueAsSignal]="form.weightKg"
		></ui-weight-form-field>

		<ui-height-form-field
			class="push-top-md"
			[title]="'Height'"
			[valueAsSignal]="form.heightCm"
			[unit]="form.preferredUnit()"
		></ui-height-form-field>
	</lib-card>

	<ui-form-save-button
		class="push-top-md"
		[title]="'Create client'"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
	></ui-form-save-button>
</div>
}
